import React, { useEffect, useState } from "react";
import "./Key_Benefits.css";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { useParams } from "react-router-dom";
import { IDS } from "../../../../utils/common";
import Common_heading from "../../../common/common_heading/Common_heading";

const Key_Benefits = () => {
  const { id } = useParams();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [serviceName, setServiceName] = useState("");
  const [keybenefit, setKeyBenefit] = useState([]);

  const getKeyBenefit = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setServiceName(res?.data?.name || "");
      setKeyBenefit(res?.data?.key_benefit_id || []);
    }
  };

  useEffect(() => {
    if (id) {
      getKeyBenefit();
    }
  }, [id]);

  return (
    <section className="Key_Benefits">
      <div className="container">
        <Common_heading
          title={<>Key Features of {htmlToReactParser.parse(serviceName)}</>}
        />

        <div className="key_benefits_wrapper">
          <div className="row justify-content-center g-4 ">
            {keybenefit.map((item, index) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                key={item?.value || index}
              >
                <div className="benefit_card">
                  <h2 className="benefit_desc">{index + 1}</h2>
                  <h4 className="benefit_title">{item?.label}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Key_Benefits;
